export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';

export const API_KEY = 'df43414b-7836-42c6-88e2-709379db0993';

export const RESULT_PER_PAGE = 10;

export const TIMEOUT_SEC = 10;
export const SUCCESS_MSG_DELAY_SEC = 2.5;
